import Vue from "vue";

import Buefy from "buefy";
Vue.use(Buefy);

import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);

import axios from "axios";

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

// Register a global custom directive called `v-focus`
Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
